
import * as THREE from 'three';


const camera = new THREE.PerspectiveCamera(50, window.innerWidth / window.innerHeight,
  0.5, 1000000);
camera.position.set(350, 200, 146)


function renderCamera() {
  console.log("相机x+" + camera.position.x + "+相机y" + camera.position.y + "+相机z+" + camera.position.z)
}
// document.addEventListener('mousemove', renderCamera);

//相机调试函数

// Create cube render target
const cubeRenderTarget = new THREE.WebGLCubeRenderTarget( 1024, { generateMipmaps: true, minFilter: THREE.LinearMipmapLinearFilter } );
cubeRenderTarget.texture.type = THREE.HalfFloatType;
const cubeCamera = new THREE.CubeCamera( 0.5, 100000, cubeRenderTarget );

cubeCamera.position.set(-9.726, -0.020, 0.486)




export { camera, cubeCamera }



